// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    // apiKey: "AIzaSyDlgE6Q60c4Xh5TQ1syf7-dnYUJBsyFvfU",
    // authDomain: "fightitaway-285807.firebaseapp.com",
    // databaseURL: "https://fightitaway-285807.firebaseio.com",
    // projectId: "fightitaway-285807",
    // storageBucket: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
    // messagingSenderId: "477855453440"
    apiKey: "AIzaSyDlgE6Q60c4Xh5TQ1syf7-dnYUJBsyFvfU",
    authDomain: "fightitaway-285807.firebaseapp.com",
    databaseURL: "https://fightitaway-285807.firebaseio.com",
    projectId: "fightitaway-285807",
    storageBucket: "fightitaway-285807.appspot.com",
    messagingSenderId: "477855453440",
    appId: "1:477855453440:web:eabe7dc365aa474a26a3e5",
    measurementId: "G-KVZ5WVR292"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
